import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'BulletedList',
})(({ brandColors, spacing, breakpoints, typography }) => ({
  orderedList: {
    marginBlock: 0,
    paddingInlineStart: 0,
    counterReset: 'item',
    listStyleType: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(1),
  },
  listItem: {
    display: 'flex',
    gap: spacing(0),
  },
  counter: {
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'center',
    alignItems: 'center',
    width: typography.pxToRem(28),
    height: typography.pxToRem(28),
    borderRadius: typography.pxToRem(24),
    color: brandColors.white,
    backgroundColor: brandColors.mediumBlue,

    [breakpoints.up('xs')]: {
      width: typography.pxToRem(32),
      height: typography.pxToRem(32),
    },
    [breakpoints.up('lg')]: {
      width: typography.pxToRem(36),
      height: typography.pxToRem(36),
    },
  },
  text: {
    flex: 1,
    marginTop: typography.pxToRem(6),
    marginBottom: typography.pxToRem(6),
  },
}));

export default useStyles;
